export default function () {
    return {
        quotes: [],
    };
}
